import { useContext } from 'react';
import UserContext from "../../contexts/userContext";

import Modal from 'react-bootstrap/Modal';import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { ChatPromptTemplate } from './2-1-1_ChatPromptTemplate';
import { retryFetch } from '../../utils';

export const getTemplates = (retryCount, {userContext, setUserContext, setAccount}) => {
    return new Promise((resolve, reject) => {
        console.log('getting templates')
        let templates = {
            command: [{
                id: "dummy",
                wizard: {
                    title: "No Template",
                    description: "Start conversation without using a template"
                }
            }]
        };
    
        const apiGatewayInvokeUrl = process.env[`REACT_APP_API_GATEWAY_INVOKE_URL__${process.env["REACT_APP_DEPLOYMENT_TYPE"]}`]
        const endpoint = `${apiGatewayInvokeUrl}/templates`;
        const params = {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${userContext.account.idToken}`
            }
        };

        fetch(endpoint, params)
            .then(response => response.json())
            .then(remoteTemplates => {
                if (templates.chat === undefined) {
                    templates.chat = {
                        withContext: remoteTemplates.chat.filter(x => x.usesContext),
                        withoutContext: remoteTemplates.chat.filter(x => !x.usesContext)
                    };
                    for (const chatTemplateType of ['withContext', 'withoutContext']) {
                        templates.chat[chatTemplateType].map((template, i) => {
                            template.i = i;
                            template.isActive = template.id.indexOf('default') > -1;
                            return template;
                        });
                    }

                    templates.command = templates.command.concat(remoteTemplates.command).map(commandTemplate => {
                        const userName = userContext.account.name;
                        
                        if (commandTemplate.wizard.contextDefault) {
                            commandTemplate.wizard.contextDefault = commandTemplate.wizard.contextDefault.replace('{{USERNAME}}', userName);
                        }
                        
                        commandTemplate.wizard.variables = commandTemplate.wizard.variables || [];
                        for (const variable of commandTemplate.wizard.variables) {
                            variable.label = variable.label.replace('{{USERNAME}}', userName);
                            variable.defaultValue = (variable.defaultValue || '').replace('{{USERNAME}}', userName);
                        }
                        return commandTemplate;
                    });

                    // const tempUserContext = {...userContext};
                    // tempUserContext.templates = templates;
                    // console.log('updating local template cache');
                    // setUserContext(tempUserContext);
                    resolve(templates);
                }
            })
            .catch(e => {
                console.log('error fetching templates', e);
                retryFetch(userContext, setAccount, retryCount||0, getTemplates, {userContext, setUserContext, setAccount});
            });
    });
    
};

export const ChatPromptTemplates = ({show, setShow}) => {
    const { userContext } = useContext(UserContext);
    
    const chatTemplates = userContext?.templates?.chat || { withContext:[], withoutContext:[] };

    return <Modal
        size="xl"
        show={show}
        onHide={() => setShow(false)}
    >
        <Modal.Header
            closeButton
            className="text-muted py-2"
            style={{"borderBottom":"none"}}
        >
            <Modal.Title>
                <i className="bi-question-square mx-2" />
                Chat Prompt Template
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4">
            <Tabs
                defaultActiveKey="withContext"
                id="fill-tab-example"
                className="mb-3"
                fill
            >
                <Tab eventKey="withContext" title="With Context">
                    <ChatPromptTemplate chatTemplates={chatTemplates.withContext} />
                </Tab>
                <Tab eventKey="withoutContext" title="Without Context">
                    <ChatPromptTemplate chatTemplates={chatTemplates.withoutContext} />
                </Tab>
            </Tabs>
        </Modal.Body>
    </Modal>
}